import { loanPropertyApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_APPLICATION_PROPERTIES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/loan-application-properties`,
  {
    GET_PROPERTIES: 'GET_PROPERTIES',
  },
);

export const getPropertiesActionV2 = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanPropertyApi.getProperties(params);

  return dispatch({
    type: LOAN_APPLICATION_PROPERTIES_ACTION_TYPE.GET_PROPERTIES,
    payload: data,
  });
});
